import { ExclamationTriangleIcon } from "@radix-ui/react-icons";
import React from "react";

export const ExternalDiagnosisExpired = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <div className="max-w-md p-6 bg-white rounded-lg shadow-md dark:bg-gray-800">
        <div className="space-y-4 flex flex-col">
          <div className="flex items-center gap-x-2">
            <h2 className="text-2xl font-bold text-red-600 dark:text-red-400">
              Link de Diagnóstico Expirado
            </h2>
            <ExclamationTriangleIcon className="size-8 text-red-600" />
          </div>
          <div className="flex flex-col gap-y-2">
            <p className="text-gray-600 dark:text-gray-400">
              O link de diagnóstico expirou. Por favor, solicite um novo link ao
              profissional responsável.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
